module.exports = __webpack_public_path__ + "img/no-preview.700bf1fb.jpg";